import React from 'react';

const Team = () => {
    return (
        <div>
            <h2>my team</h2> 
        </div>
    );
};

export default Team;